import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Button, Typography, Alert } from '@mui/material';
import CreateBomItemComponent from '../component/CreateBomItemComponent';
import BomItemsList from '../lists/bomItemsList';
import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import { useGetBomByIdQuery } from '../../../redux/vmsApi';
import { formatCurrency } from '../../../utils/currencyUtil';

const BomItemsPage: React.FC = () => {
  const { bomId } = useParams<{ bomId: string }>();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<any>(null);

  const { data: bomDetails } = useGetBomByIdQuery(
    { id: bomId ?? '' },
    { skip: !bomId }
  );

  const bomSummary = bomDetails as any;

  if (!bomId) {
    return (
      <Alert severity="error">
        BOM ID is required. Please navigate from the BOM Management page.
      </Alert>
    );
  }

  const handleEdit = (item: any) => {
    setEditingItem(item);
    setCreateDialogOpen(true);
  };

  const handleCreateClick = () => {
    setEditingItem(null);
    setCreateDialogOpen(true);
  };

  const handleSuccess = () => {
    setCreateDialogOpen(false);
    setEditingItem(null);
  };

  const handleClose = () => {
    setCreateDialogOpen(false);
    setEditingItem(null);
  };

  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        {bomSummary?.title || 'BOM Items'}
      </Typography>
      <Typography variant='h6' sx={{ color: 'text.secondary', mb: 2 }}>
        {`Project: ${bomSummary?.project?.name || '-'} | Budget Total: ${formatCurrency(Number(bomSummary?.totalBudget ?? 0), 'usd')}`}
      </Typography>
      <Paper sx={{ my: 5 }}>
        <Button
          variant="contained"
          onClick={handleCreateClick}
          sx={{ m: 2 }}
        >
          Add BOM Item
        </Button>

        <CreateBomItemComponent
          bomId={bomId}
          editingItem={editingItem}
          open={createDialogOpen}
          onClose={handleClose}
          onSuccess={handleSuccess}
        />
      </Paper>
      <Paper sx={{ my: 5 }}>
        <BomItemsList
          bomId={bomId}
          onEdit={handleEdit}
        />
      </Paper>
    </ProcurementContainer>
  );
};

export default BomItemsPage;
